import { Radio, Space } from 'antd'
import { Rule } from 'antd/lib/form'
import styled, { css } from 'styled-components'

import { RadioCaptureBlock as RadioCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import { useBreakpoint } from '@/hooks/useBreakpoint'

type WrapperProps = {
  isMobile: boolean
}

const ResponsiveRadioWrapper = styled.div<WrapperProps>`
  ${({ isMobile }) =>
    isMobile &&
    css`
      .ant-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem 0;

        .ant-radio-button-wrapper {
          text-align: center;
          flex-grow: 1;
        }
      }
    `}
`

type Props = {
  block: RadioCaptureBlockType
  rules: Rule[]
}

export const RadioCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const isMobile = useBreakpoint('lg')
  const { radioButtons = [], optionType = 'default', id } = block

  const defaultSelected = radioButtons
    .filter((radio) => radio.checked)
    .map((radio) => radio.value)

  const prepOptions = radioButtons.map((radio, i) => ({
    ...radio,
    value: radio.value || `${id}-[${i}]`,
  }))

  return (
    <ResponsiveRadioWrapper isMobile={isMobile}>
      <CaptureBlockFormItem
        initialValue={defaultSelected[0]}
        style={{ marginBottom: '0' }}
        rules={rules}
        block={block}
      >
        {optionType === 'button' ? (
          <Radio.Group
            options={prepOptions}
            optionType={optionType}
            buttonStyle="solid"
            size="large"
          />
        ) : (
          <Radio.Group>
            <Space direction="vertical">
              {prepOptions.map((option) => (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        )}
      </CaptureBlockFormItem>
    </ResponsiveRadioWrapper>
  )
}
